<template>
	<div id="main" class="column is-9">
        <LoginHistory :id="user_id" />
    </div>
</template>

<script>
    import LoginHistory from "../shared/LoginHistory.vue"
    export default {
        components: {
            LoginHistory,
        },
        data() {
            return {
                user_id: null
            }
        },
        created() {
            this.user_id = JSON.parse(localStorage.getItem('user')).user_id
        }
    }
</script>